import { Checkbox, Grid, InputAdornment, ListItemText, MenuItem, TextField } from '@material-ui/core';
import { InvertedChevronIcon } from 'components/Icons';
import React, { useCallback, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import textRange from 'utils/TextRange';
import { filtrosInitialState, filtrosReducer } from './reducer';
import useStyle from './style';




interface FilterParams {
  coops?: string[];
  colaborador?: boolean;
  data?: string;
  cpfOrNome?: string;
}

interface Props {
  listaCoops: Array<string>;
  onChangeFilter: (params: FilterParams) => void;
}

export default function ({ listaCoops, onChangeFilter }: Props) {
  const { t } = useTranslation();
  const classes = useStyle();
  const [{ cpfOrNome, coops, colaborador }, dispatch] = useReducer(
    filtrosReducer,
    filtrosInitialState
  );

  const handleCoopsChange = useCallback(
    (event: React.ChangeEvent<{ value: unknown }>) => {
      const value = event.target.value as string[];
      dispatch({ type: 'setCoops', value });
      onChangeFilter({ coops: value.length > 0 ? value : undefined });
    },
    [onChangeFilter]
  );

  const handleColaboradorChange = useCallback(
    (event: React.ChangeEvent<{ value: unknown }>) => {
      const numericValue = event.target.value as number;
      if (numericValue < 0) {
        dispatch({ type: 'setColaborador', value: undefined });
        onChangeFilter({ colaborador: undefined });
      } else {
        dispatch({ type: 'setColaborador', value: numericValue > 0 });
        onChangeFilter({ colaborador: numericValue > 0 });
      }
    },
    [onChangeFilter]
  );

  const handleCPFChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = textRange(event.target.value, 35).replace(/[-/]/g, '').replace(/\.(?=\d)/g, '');
      dispatch({ type: 'setSearch', value });
      if (value.length >= 3) {
        onChangeFilter({ cpfOrNome: value });
      } else {
        onChangeFilter({ cpfOrNome: undefined });
      }
    },
    [onChangeFilter]
  );

  return (
    <Grid container spacing={3} className={classes.root}>
      <Grid item xs={12} sm={12} md={4}>
        <TextField
          select
          label={t('ConvocadosAssessor.labelFiltroCoops')}
          SelectProps={{
            IconComponent: () => (
              <InputAdornment position="end" className={classes.selectIcon}>
                <InvertedChevronIcon />
              </InputAdornment>
            ),
            multiple: true,
            value: coops,
            renderValue: selected => (selected as string[]).join(', '),
            onChange: handleCoopsChange,
          }}
          disabled={!listaCoops.length}
          fullWidth
        >
          {listaCoops.map(entry => (
            <MenuItem key={entry} value={entry}>
              <Checkbox checked={(coops || []).includes(entry)} color="primary" />
              <ListItemText primary={entry} />
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <TextField
          select
          label={t('ConvocadosAssessor.labelFiltroColaborador')}
          SelectProps={{
            IconComponent: () => (
              <InputAdornment position="end" className={classes.selectIcon}>
                <InvertedChevronIcon />
              </InputAdornment>
            ),
            value: colaborador !== undefined ? (colaborador ? 1 : 0) : -1,
            renderValue: selected => {
              if ((selected as number) === 1) return 'Sim';
              if ((selected as number) === 0) return 'Não';
              return 'Todos';
            },
            onChange: handleColaboradorChange,
          }}
          fullWidth
        >
          <MenuItem value={-1} selected={colaborador === undefined}>
            Todos
          </MenuItem>
          <MenuItem value={1} selected={colaborador}>
            Sim
          </MenuItem>
          <MenuItem value={0} selected={colaborador === false}>
            Não
          </MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <TextField
          label={t('ConvocadosAssessor.labelFiltroCPFOrNpme')}
          value={cpfOrNome}
          onChange={handleCPFChange}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
